import getMessagingServiceInstance from 'services/MessagingService/MessagingService';
import { MODAL_CLOSED } from 'services/MessagingService/EventNames';
import trackingService from 'services/UITrackingService';
import logger from 'logger';


/**
 * Modal keys object to hold all keys of modals, which will be used for identifying
 * unique modal that need to be rendered.
 * Values are used when is called showModal to determine which modal caller want to show,
 * and in ModalRenderer to map modal key to modal component reference.
 *
 * If you add new modals to be handled over ModalService add new modal key here.
 */
enum ModalKeys {
  COOMING_SOON_MODAL = 'COOMING_SOON_MODAL',
  BEAT_TIP_LEADER_MODAL = 'BEAT_TIP_LEADER_MODAL',
  BROADCASTING_CONSENT_MODAL = 'BROADCASTING_CONSENT_MODAL',
  BROADCAST_MOBILE_CONSENT_MODAL = 'BROADCAST_MOBILE_CONSENT_MODAL',
  PRIVATE_TIP_MODAL = 'PRIVATE_TIP_MODAL',
  // DEPRECATED
  BUY_GIFTS_MODAL = 'BUY_GIFTS_MODAL',
  BUY_ALL_VIDEOS_MODAL = 'BUY_ALL_VIDEOS_MODAL',
  MY_SHOP_VIDEO_MODAL = 'MY_SHOP_VIDEO_MODAL',
  PRIVATE_MESSAGE_MODAL = 'PRIVATE_MESSAGE_MODAL',
  CHAT_CONTEXTUAL_OVERLAY = 'CHAT_CONTEXTUAL_OVERLAY',
  JOIN_FAN_CLUB_MODAL = 'JOIN_FAN_CLUB_MODAL',
  PROMO_OVERLAY = 'PROMO_OVERLAY',
  REGISTRATION_GOLD_MODAL = 'REGISTRATION_GOLD_MODAL',
  REGISTRATION_MODAL = 'REGISTRATION_MODAL',
  GUEST_REGISTRATION_MODAL = 'GUEST_REGISTRATION_MODAL',
  GUEST_BILLING_MODAL = 'GUEST_BILLING_MODAL',
  UNLINK_PROCESSOR_MODAL = 'UNLINK_PROCESSOR_MODAL',
  SET_AS_DEFAULT_PROCESSOR_MODAL = 'SET_AS_DEFAULT_PROCESSOR_MODAL',
  PRIVATE_SHOW_CONFIRMATION_MODAL = 'PRIVATE_SHOW_CONFIRMATION_MODAL',
  GROUP_SHOW_CANCELED_MODAL = 'GROUP_SHOW_CANCELED_MODAL',
  GROUP_SHOW_GOAL_REACHED_MODAL = 'GROUP_SHOW_GOAL_REACHED_MODAL',
  SFW_IMAGE_MODAL = 'SFW_IMAGE_MODAL',
  TOKEN_HOLDERS_ALLOWED_MODAL = 'TOKEN_HOLDERS_ALLOWED_MODAL',
  ONE_CLICK_RETENTION_MODAL = 'ONE_CLICK_RETENTION_MODAL',
  AUTO_RELOAD_MODAL = 'AUTO_RELOAD_MODAL',
  SEND_GIFT_MODAL = 'SEND_GIFT_MODAL',
  SEND_QUICK_GIFT_MODAL = 'SEND_QUICK_GIFT_MODAL',
  DELETE_COMMENT_MODAL = 'DELETE_COMMENT_MODAL',
  INSUFFICIENT_BALANCE_MODAL = 'INSUFFICIENT_BALANCE_MODAL',
  BEAT_THE_LEADER = 'BEAT_THE_LEADER',
  DESKTOP_COMPLETE_GOAL_MODAL = 'DESKTOP_COMPLETE_GOAL_MODAL',
  ADMIN_LANGUAGE_OVERRIDE_MODAL = 'ADMIN_LANGUAGE_OVERRIDE_MODAL',
  CAMPAIGN_OVERLAY_MOBILE = 'CAMPAIGN_OVERLAY_MOBILE',
  GROUP_SHOW_BUY_TICKET_MODAL = 'GROUP_SHOW_BUY_TICKET_MODAL',
  GROUP_SHOW_GOAL_MODAL = 'GROUP_SHOW_GOAL_MODAL',
  CHAT_CONTEXTUAL_MENU_CONFIRM_OPTION = 'CHAT_CONTEXTUAL_MENU_CONFIRM_OPTION',
  CHAT_CONTEXTUAL_MENU_REPORT = 'CHAT_CONTEXTUAL_MENU_REPORT',
  CHAT_CONTEXTUAL_MENU_KICK = 'CHAT_CONTEXTUAL_MENU_KICK',
  CHAT_CONTEXTUAL_MENU_BAN = 'CHAT_CONTEXTUAL_MENU_BAN',
  CHAT_CONTEXTUAL_MENU_PERMA_BAN = 'CHAT_CONTEXTUAL_MENU_PERMA_BAN',
  CHAT_CONTEXTUAL_MENU_FAN_BAN = 'CHAT_CONTEXTUAL_MENU_FAN_BAN',
  CHAT_CONTEXTUAL_MENU_FAN_PERMA_BAN = 'CHAT_CONTEXTUAL_MENU_FAN_PERMA_BAN',
  CHAT_CONTEXTUAL_MENU_DELETE_KICK = 'CHAT_CONTEXTUAL_MENU_DELETE_KICK',
  CHAT_CONTEXTUAL_MENU_CLOSE_ROOM = 'CHAT_CONTEXTUAL_MENU_CLOSE_ROOM',
  CHAT_CONTEXTUAL_MENU_FEATURE_BROADCASTER = 'CHAT_CONTEXTUAL_MENU_FEATURE_BROADCASTER',
  CONTINUE_PURCHASE_OR_JOIN_FANCLUB_MODAL = 'CONTINUE_PURCHASE_OR_JOIN_FANCLUB_MODAL',
  ALL_AWARDS = 'ALL_AWARDS',
  REQUEST_PRIVATE_SHOW_MODAL = 'REQUEST_PRIVATE_SHOW_MODAL',
  DELETE_MODAL = 'DELETE_MODAL',
  SHOW_INVITE_MODAL = 'SHOW_INVITE_MODAL',
  DISABLE_SHOW_INVITES_MODAL = 'DISABLE_SHOW_INVITES_MODAL',
  BOOST_MODAL = 'BOOST_MODAL',
  SAFARI_14_MODAL = 'SAFARI_14_MODAL',
  CLOSE_CONVERSATION_MODAL = 'CLOSE_CONVERSATION_MODAL',
  GIFT_MODAL = 'GIFT_MODAL',
  GIFT_CATEGORY_MODAL = 'GIFT_CATEGORY_MODAL',
  WEAK_PASSWORD_MODAL = 'WEAK_PASSWORD_MODAL',
  ADMIN_CSV_MESSAGES_MODAL = 'ADMIN_CSV_MESSAGES_MODAL',
  SEND_USER_GIFT_MODAL = 'SEND_USER_GIFT_MODAL',
  PRIVATE_DIRECTORY_MODAL_MESSAGE = 'PRIVATE_DIRECTORY_MODAL_MESSAGE',
  PRIVATE_DIRECTORY_MODAL_CALL = 'PRIVATE_DIRECTORY_MODAL_CALL',
  PRIVATE_DIRECTORY_MODAL_IN_ANOTHER_CALL = 'PRIVATE_DIRECTORY_MODAL_IN_ANOTHER_CALL',
  PRIVATE_DIRECTORY_VIEW_MORE = 'PRIVATE_DIRECTORY_VIEW_MORE',
  ALL_GIFTS_MODAL = 'ALL_GIFTS_MODAL',
  ADD_NEW_TAG_MODAL = 'ADD_NEW_TAG_MODAL',
  REMOVE_BROADCASTER_FROM_LIST_MODAL = 'REMOVE_BROADCASTER_FROM_LIST_MODAL',
  ADD_BROADCASTER_TO_SPONSORED_TAG_MODAL = 'ADD_BROADCASTER_TO_SPONSORED_TAG_MODAL',
  ADD_STUDIO_BROADCASTERS_TO_TAG_MODAL = 'ADD_STUDIO_BROADCASTERS_TO_TAG_MODAL',
  DELETE_SPONSORED_TAG_MODAL = 'DELETE_SPONSORED_TAG_MODAL',
  LOGIN_MODAL_V2 = 'LOGIN_MODAL_V2',
  LOGIN_V2_UNVERIFIED_USER_MODAL = 'LOGIN_V2_UNVERIFIED_USER_MODAL',
  LOGIN_V2_SECURITY_QUESTION_FORM_MODAL = 'LOGIN_V2_SECURITY_QUESTION_FORM_MODAL',
  LOGIN_V2_ACCOUNT_EXPIRED_MODAL = 'LOGIN_V2_ACCOUNT_EXPIRED_MODAL',
  LOGIN_V2_2FA_MODAL = 'LOGIN_V2_2FA_MODAL',
  PASSWORD_RESET_V2_MODAL = 'PASSWORD_RESET_V2_MODAL',
  ADMIN_BANNED_USER_ACCOUNT = 'ADMIN_BANNED_USER_ACCOUNT',
  BROADCASTER_MESSAGE_DISABLED_MODAL = 'BROADCASTER_MESSAGE_DISABLED_MODAL',
  REGIONAL_PACKAGES_MODAL = 'REGIONAL_PACKAGES_MODAL',
  ADMIN_CONFIRM_MODAL = 'ADMIN_CONFIRM_MODAL',
  PROFILE_V2_FEEDBACK_MODAL = 'PROFILE_V2_FEEDBACK_MODAL',
  DMCA_SUBMIT_MODAL = 'DMCA_SUBMIT_MODAL',
  ADMIN_BULK_BAN_MODAL = 'ADMIN_BULK_BAN_MODAL',
  SHAFT_TRAFFIC_ADS_MODAL = 'SHAFT_TRAFFIC_ADS_MODAL',
  UPGRADE_TO_GOLD_MODAL_V2 = 'UPGRADE_TO_GOLD_MODAL_V2',
  UPGRADE_TO_GOLD_CONTEXTUAL = 'UPGRADE_TO_GOLD_CONTEXTUAL',
  TIP_MENU_MODAL = 'TIP_MENU_MODAL',
  ACHIEVEMENT_MODAL = 'ACHIEVEMENT_MODAL',
  INFORM_PENDING_ONBOARDING_MODAL = 'INFORM_PENDING_ONBOARDING_MODAL',
  BROADCAST_TYPE_ONBOARDING_MODAL = 'BROADCAST_TYPE_ONBOARDING_MODAL',
  BASIC_REDIRECT_ONBOARDING_MODAL = 'BASIC_REDIRECT_ONBOARDING_MODAL',
  CASH_OUT_RESTRICTED_MODAL = 'CASH_OUT_RESTRICTED_MODAL',
  NEEDS_ID_MODAL = 'NEEDS_ID_MODAL',
  ONBOARDING_EMERGENCY_MODAL = 'ONBOARDING_EMERGENCY_MODAL',
  INFORM_MULTIPLE_IDENTITIES_ONBOARDING_MODAL = 'INFORM_MULTIPLE_IDENTITIES_ONBOARDING_MODAL',
  BROADCAST_END_MODAL = 'BROADCAST_END_MODAL',
  BROADCASTER_CONNECT_TOY_MODAL = 'BROADCASTER_CONNECT_TOY_MODAL',
  PREDEFINED_TAGS_MODAL = 'PREDEFINED_TAGS_MODAL',
  TWITTER_CONNECT_ACCOUNT_MODAL = 'TWITTER_CONNECT_ACCOUNT_MODAL',
  SEND_TWEET_MODAL = 'SEND_TWEET_MODAL',
  GS_SETTINGS_MODAL = 'GS_SETTINGS_MODAL',
  BROADCASTER_GROUP_SHOW_GOAL_REACHED = 'BROADCASTER_GROUP_SHOW_GOAL_REACHED',
  BROADCASTER_GROUP_SHOW_CANCEL = 'BROADCASTER_GROUP_SHOW_CANCEL',
  BROADCASTER_GROUP_SHOW_TIME_REACHED = 'BROADCASTER_GROUP_SHOW_TIME_REACHED',
  BROADCASTER_GROUP_SHOW_LAST_CHANCE = 'BROADCASTER_GROUP_SHOW_LAST_CHANCE',
  PS_SETTINGS_MODAL = 'PS_SETTINGS_MODAL',
  NEW_NOTE_MODAL = 'NEW_NOTE_MODAL',
  BROADCASTER_END_PRIVATE_SHOW_MODAL = 'BROADCASTER_END_PRIVATE_SHOW_MODAL',
  SPEED_TEST_MODAL = 'SPEED_TEST_MODAL',
  BROADCASTER_PS_ENDED_RATING_MODAL = 'BROADCASTER_PS_ENDED_RATING_MODAL',
  BROADCASTER_WINDOW_INTRODUCTION_MODAL = 'BROADCASTER_WINDOW_INTRODUCTION_MODAL',
  BROADCAST_OBS_VIRTUAL_CAMERA_WARNING_MODAL = 'BROADCAST_OBS_VIRTUAL_CAMERA_WARNING_MODAL',
  BROADCAST_ERROR_MODAL = 'BROADCAST_ERROR_MODAL',
  ERROR_MODAL = 'ERROR_MODAL',
  MORE_INFO_ABOUT_ID_MODAL = 'MORE_INFO_ABOUT_ID_MODAL',
  PORNDOE_MODAL = 'PORNDOE_MODAL',
  NON_PURCHASED_OVERLAY = 'NON_PURCHASED_OVERLAY',
  FANCLUB_VIDEO_OVERLAY = 'FANCLUB_VIDEO_OVERLAY',
  ADD_IMAGES_MODAL = 'ADD_IMAGES_MODAL',
  CONFIRMATION_MODAL = 'CONFIRMATION_MODAL',
  FANCLUB_VIDEO_PREVIEW_MODAL = 'FANCLUB_VIDEO_PREVIEW_MODAL',
  VIDEO_COVER_MODAL = 'VIDEO_COVER_MODAL',
  ADD_MEDIA_MODAL = 'ADD_MEDIA_MODAL',
  SHARE_MEDIA_MODAL = 'SHARE_MEDIA_MODAL',
  EDIT_MEDIA_MODAL = 'EDIT_MEDIA_MODAL',
  AUTOTWEET_IMAGE_MODAL = 'AUTOTWEET_IMAGE_MODAL',
  GUEST_CONTENT_OVERLAY = 'GUEST_CONTENT_OVERLAY',
  WEBRTC_OBS_MEDIA_NOT_SUPPORTED = 'WEBRTC_OBS_MEDIA_NOT_SUPPORTED',
}

type ModalProps = {
  [key: string]: any,
};

type ModalEntry = {
  modalKey: keyof typeof ModalKeys,
  modalProps: ModalProps,
};

type Callback = (modalEntry: ModalEntry) => any;

/**
 * @ModalService singleton class for managing modal state.
 * Provides showModal/hideModal methods for all modals in application.
 */
class ModalService {
  MODAL_KEYS = ModalKeys;
  messagingService = getMessagingServiceInstance();

  /**
   * Active modal state.
   */
  activeModal: ModalEntry = null;

  /**
   * Array of function references to listeners,
   * which is called in emit change after showModal/hideModal methods.
   */
  events: Callback[] = [];

  /**
   * Method showModal represents main method of service for showing modals with input param called activeModal object,
   * which is set to this.activeModal.
   * When showModal is called is emitted change event by calling all listeners that listen to change of active modal.
   * @param modalKey name of modal which should be shown.
   * @param modalProps to be passed to modal when modal is rendered. Equivalent to react input props.
   */
  showModal = (modalKey?: keyof typeof ModalKeys, modalProps = {}): void => {
    if (!modalKey || !ModalKeys[modalKey]) {
      logger.error('Provided modalKey not exist in ModalService.MODAL_KEYS');

      return;
    }

    this.activeModal = { modalKey, modalProps: modalProps || {} };
    this.emitChange();

    trackingService.emit('openModal', { key: modalKey });
  };

  /**
   * Method hideModal for hiding current active modal.
   * When hideModal is called is emitted change event by calling all listeners that listen to change of active modal.
   * Emit 'MODAL_CLOSED' event
   */
  hideModal = (): void => {
    if (!this.activeModal) {
      return;
    }

    const modalName = this.activeModal;
    this.activeModal = null;
    this.emitChange();
    this.messagingService.emit(MODAL_CLOSED, { modalName });

    trackingService.emit('closeModal', { key: modalName.modalKey });
  };

  /**
   * Method addChangeListener to add listener which will be called after showModal/hideModal methods.
   * @param callback reference to listener function.
   */
  addChangeListener = (callback: Callback): void => {
    this.events.push(callback);
  };

  /**
   * Method removeChangeListener to remove listener which will be called after showModal/hideModal methods.
   * @param callback reference to listener function.
   */
  removeChangeListener = (callback: Callback): void => {
    this.events = this.events.filter((x) => x !== callback);
  };

  /**
   * Called after showModal/hideModal,
   * this method calls all previously added listeners and send to collback this.activeModal object.
   */
  emitChange = (): void => {
    this.events.forEach((callback: Callback) => callback(this.activeModal));
  };

  /**
   * Method isModalActive is for checking if there is any active modal at the time.
   */
  isModalActive = (): boolean => this.activeModal !== null;

  getActiveModalKey = (): keyof typeof ModalKeys => this.activeModal?.modalKey;
}

export default new ModalService();
